<!-- error listing popup -->
@if (showPopUp && errorList.length) {
   <div class="modal error-list-modal fade show d-block" id="error-warning" tabindex="-1" aria-labelledby="confirmation-modal" aria-modal="true" role="dialog">
       <div class="modal-dialog modal-dialog-centered modal-medium" style="opacity: 1!important;">
         <div class="modal-content">
           <div class="modal-body">
             <div class="confirm-modal-body">
               <h2 id="confirmation-modal">{{headTitle}}</h2>
               <div class="project-table">
                 <table class="table error-list-table">
                   <thead>
                     <tr>
                       @for (eHead of errorTableHead; track $index) {
                         <th>{{ eHead.head }}</th>
                       }
                     </tr>
                   </thead>
                   <tbody>
                     @for (eItem of errorList; track $index) {
                       <tr>
                         @for (eHead of errorTableHead; track $index) {
                           <td>
                             @if (eHead.isRepeated) {
                               @for (err of eItem[eHead.field]; track $index) {
                                 <p>{{ err }}</p>
                               }
                             } @else {
                               {{ eItem[eHead.field] }}
                             }
                           </td>
                         }
                       </tr>
                     }
                   </tbody>
                 </table>
               </div>
               <div class="confirm-buttons d-flex justify-content-end">
                     <button class="btn btn-primary" id="confirmation-okay-btn" (click)="onClosePopUp()">Ok</button>
                   </div>
             </div>
           </div>
         </div>
       </div>
     </div>
 }
